import gql from 'graphql-tag';

export const GET_AFTERMARKET_ADDONS_PRODUCTS_OPTIONS = gql`
  query GetAftermarketAddonsProductsOptions($accountId: ID!) {
    options: aftermarketAddonsProducts(accountId: $accountId) {
      label: productName
      value: aftermarketProductId
    }
  }
`;
